import styled from "styled-components";
import { COLORS, FONTS, HELPERS } from "../../shared";
import { ButtonStyledInterface } from "../../entities/Button";
import { MEDIA_QUERY } from "../../entities/Common";

export const ButtonStyled = styled.button<ButtonStyledInterface>`
  border: 0;
  outline: 0;
  background: ${(props) =>
    props.disabled ? COLORS.GRAY : COLORS.PRIMARY_YELLOW};
  border: 2px solid
    ${(props) => (props.disabled ? COLORS.GRAY : COLORS.PRIMARY_YELLOW)};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  padding-left: 20px;
  pointer-events: ${(props) => (props.disabled ? "none" : null)};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  padding-right: 20px;
  cursor: pointer;
  box-sizing: border-box;
  width: ${(props: ButtonStyledInterface) => props.width ?? "auto"};
  margin: ${(props: ButtonStyledInterface) => props.$margin ?? "0 0 0 0"};
  transition: ${HELPERS.TRANSITION};
  &:hover {
    background: ${COLORS.YELLOW};
    border: 2px solid ${COLORS.YELLOW};
  }
  span {
    font-weight: ${FONTS.FONT_WEIGHT_BOLD};
    color: ${(props) => (props.disabled ? COLORS.GRAY_TWO : COLORS.WHITE)};
    font-size: ${FONTS.FONT_SIZE_NORMAL};
  }
  &.transparent {
    background: transparent;
    border: 2px solid ${COLORS.PRIMARY_DARK};
    transition: ${HELPERS.TRANSITION};
    span {
      color: ${COLORS.PRIMARY_DARK};
      transition: ${HELPERS.TRANSITION};
    }
    &:hover {
      background: ${COLORS.PRIMARY_DARK};
      span {
        color: ${COLORS.WHITE};
      }
    }
  }
  &.green {
    background: ${COLORS.GREEN};
    border: 2px solid ${COLORS.GREEN};
    transition: ${HELPERS.TRANSITION};
    span {
      color: ${COLORS.WHITE};
    }
    &:hover {
      background: ${COLORS.GREEN_HOVER};
      border: 2px solid ${COLORS.GREEN_HOVER};
    }
  }
  &.small {
    height: 30px;
    padding: 0 10px;
    span {
      font: normal normal normal 16px/18px Arial;
    }
  }
  &.condiment-btn {
    height: 40px;
    padding-left: 11px;
    padding-right: 11px;
    span {
      white-space: nowrap;
      font: normal normal normal 16px/18px Arial;
    }
  }

  &.full-btn {
    border-radius: 2.5px;
    width: 100%;
  }

  &.toggle-button {
    background-color: transparent;
    border: 1px solid #282828;
    padding: 20px;
    border-radius: 5px;
    span {
      color: #282828;
      font-size: 18px;
      font-weight: 500;
    }
    &.active {
      background-color: #282828;
      span {
        color: #fff;
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.TABLET_HORIZONTAL}) {
    height: 30px;
    span {
      font-size: 14px;
    }
  }
  @media (max-width: ${MEDIA_QUERY.MOBILE}) {
    span {
      font-size: 12px;
    }
    &.condiment-btn {
      height: 30px;
      white-space: nowrap;
      span {
        font: normal normal normal 14px/18px Arial;
      }
    }
    &.small {
      span {
        font: normal normal normal 12px/18px Arial;
      }
    }
    &.transparent {
      span {
        font-size: 12px;
      }
    }
  }
`;
